<section class="rounded-lg border border-greyscale-200 bg-white p-4">
  <div class="mb-4 flex items-start gap-3">
    <div class="shrink-0 rounded-full bg-greyscale-200 p-2 text-greyscale-600">
      <lucide-angular [img]="PenLine" class="h-4 w-4" />
    </div>
    <div>
      <h4 class="text-heading-4 text-primary-900">
        {{ "objectives.customActionsTitle" | transloco }}
      </h4>
      <p class="mt-0.5 text-paragraph-s-reg text-greyscale-600">
        {{ "objectives.customActionsSubtitle" | transloco }}
      </p>
    </div>
  </div>

  @if (customActions().length > 0) {
    <ul class="mb-3 space-y-2">
      @for (action of customActions(); track $index; let i = $index) {
        <li
          class="flex items-center gap-3 rounded-lg border border-greyscale-200 bg-greyscale-50 px-3 py-2"
        >
          <i class="pi pi-check-square shrink-0 text-greyscale-500"></i>
          <span class="flex-1 text-paragraph-s-reg text-greyscale-700">{{ action }}</span>
          <button
            type="button"
            (click)="removeCustomAction(i)"
            [disabled]="isSaving()"
            class="shrink-0 text-greyscale-400 transition-colors hover:text-error-500"
          >
            <i class="pi pi-times text-paragraph-xs-reg"></i>
          </button>
        </li>
      }
    </ul>
  }

  @if (isAddingCustom()) {
    <div class="flex items-center gap-2">
      <input
        pInputText
        [(ngModel)]="newActionText"
        [placeholder]="'objectives.sdgCustomActionPlaceholder' | transloco"
        (keyup.enter)="addCustomAction()"
        (keyup.escape)="cancelCustomAction()"
        class="flex-1 text-paragraph-s-reg"
      />
      <p-button
        type="button"
        icon="pi pi-check"
        severity="secondary"
        size="small"
        [rounded]="true"
        (onClick)="addCustomAction()"
        [disabled]="!newActionText().trim()"
      />
      <p-button
        type="button"
        icon="pi pi-times"
        severity="secondary"
        size="small"
        [rounded]="true"
        [text]="true"
        (onClick)="cancelCustomAction()"
      />
    </div>
  } @else {
    <p-button
      (click)="isAddingCustom.set(true)"
      fluid="true"
      size="small"
      [text]="true"
      styleClass="!justify-start"
    >
      <i class="pi pi-plus text-paragraph-xs-reg"></i>
      {{ "objectives.addNewAction" | transloco }}
    </p-button>
  }
</section>
